// extracted by mini-css-extract-plugin
module.exports = {"carSpecifications":"_2zOoA","singleTitle":"Rjq3_","tableView":"_1cUJ3","ctaText":"_2Oe7l","tableHeaderStrip":"_117LP","tabNavs":"C1ZR5","active":"_2uMsq"};